import styled from 'styled-components';

import {
  Icon,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

export const TableCell = styled(Flex).attrs({
  row: true,
  align: 'center',
})`
  flex: 0 0 ${50 / 3}%;
  color: #7e7e7e;
`;

export const TableRow = styled(Flex).attrs({
  row: true,
  justify: 'space-between',
  align: 'center',
  width: '100%',
  height: 61,
})`
  min-height: 61px;
  &:not(:last-child) {
   border-bottom: 1px solid #ededed;
  }

  ${TableCell}:nth-child(2){
    flex: 0 0 50%;
  }
`;

export const TableHeader = styled(TableRow)`
  ${TableCell} {
    color: #c0c0c0;
  }
`;

export const Succeeded = styled(Icon).attrs(
  props => ({
    size: '17px',
    type: 'far fa-check-circle',
    color: props.theme.colors.success,
  }),
)``;

export const Failure = styled(Icon).attrs(
  props => ({
    size: '17px',
    type: 'far fa-times-circle',
    color: props.theme.colors.danger,
  }),
)``;
